module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/112.94669ea3.png";